<div class="container">

  
  <div class="d-flex justify-content-between align-items-center mb-20">
      <!-- Header -->
  <div class="header">
    <mat-icon class="header-icon">shield</mat-icon>
    <div>
      <div class="header-title">Question Weights & Mandatory Rules</div>
      <div class="header-subtitle">
        Configure weight (1-10) and optional mandatory rules for each question
      </div>
    </div>
  </div>

  <!-- Info Box -->
  <div class="info-box">
    <mat-icon class="info-icon">info</mat-icon>
    <div>
      <div>
        <b>Mandatory Pass:</b> If this question fails, the entire evaluation auto-fails.
      </div>
      <div>
        <b>Mandatory Fail:</b> If this question passes, the entire evaluation auto-passes.
      </div>
    </div>
  </div>
  </div>

  <!-- Count Banner -->
  <div class="count-banner">
     {{rulesCount.length}} mandatory rules configured
    <!-- {{ rules.filter(r => r.mandatory).length }} mandatory rules configured -->
  </div>

 <div class="addQuerstion saveField" *ngIf="rules.length>0">             
   <button (click)="UpdateThresholdRules()">Update</button> 
 </div>
 
 <div cdkDropList class="rules-container" (cdkDropListDropped)="dropRule($event)">

  <div class="rule-card" *ngFor="let rule of rules; let i = index" cdkDrag>

    <!-- Placeholder -->
    <div class="drag-placeholder" *cdkDragPlaceholder></div>

    <!-- HEADER -->
    <div class="rule-header">

      <!-- DRAG HANDLE -->
      <mat-icon class="drag-icon" cdkDragHandle  matTooltip="Drag to reorder">
        drag_indicator
      </mat-icon>

      <!-- TITLE -->
      <div class="rule-title">
        {{ rule.questionTitle }}
      </div>

      <!-- ACTIONS -->
      <div class="header-actions">
        <button mat-icon-button
          class="edit-btn" matTooltip="Edit"
          (click)="editRule(rule, i)">
          <mat-icon>edit</mat-icon>
        </button>

        <button mat-icon-button
          class="delete-btn" matTooltip="Delete"
          (click)="deleteRule(rule, i)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>

    </div>

    <!-- BODY -->
    <div class="weight-row">
      <span class="weight-label">Weight:</span>

      <mat-slider color="primary"
        class="slider" min="1" max="10" step="1"
        [(ngModel)]="rule.weight">
      </mat-slider>

      <input class="weight-box" [value]="rule.weight" readonly />
    </div>

    <!-- FOOTER -->
    <div class="footer">
      <mat-checkbox color="primary"
        [(ngModel)]="rule.mandatoryRule"
        (change)="onMandatoryChange($event, rule)">
        Mandatory Rule
      </mat-checkbox>

      <div class="type-box" *ngIf="rule.mandatoryRule">
        <span>Type:</span>

        <button class="pill"
          [class.active]="rule.isMandatoryPass"
          (click)="onTypeSelect('PASS', rule)">
          Mandatory Pass
        </button>

        <button class="pill"
          [class.active1]="!rule.isMandatoryPass"
          (click)="onTypeSelect('FAIL', rule)">
          Mandatory Fail
        </button>
      </div>
    </div>

  </div>
</div>



</div>
